<template>
  <DefaultLayout
    menuIndex="/instructions/instructionsList"
    openeds="instructions"
  >

    <div class="page-header">
      <el-page-header @back="goPath('/instructions/instructionsList')">
        <template #content>
          <span class="text-large font-600 mr-3"> 编辑说明书 </span>
        </template>
      </el-page-header>
    </div>

    <div style="padding:20px">
      <el-form
        :model="form"
        label-width="80px"
        ref="ruleFormRef"
        label-position="left"
      >
        <el-form-item
          label="名称"
          prop="name"
        >
          <el-input
            v-model="form.name"
            style="width: 450px;"
          />
        </el-form-item>
        <el-form-item
          label="备注"
          prop="desc"
        >
          <el-input
            v-model="form.desc"
            type="textarea"
            style="width: 450px;"
            :rows="5"
          />
        </el-form-item>

        <el-form-item label="操作视频">
          <el-upload
            :on-preview="handlePreview"
            class="upload-demo"
            action
            :http-request="(file) => uploadFile(file, 'video')"
            ref="upload"
            :limit="fileLimit"
            :on-remove="handleRemoveVideo"
            :file-list="fileVideoList"
            :on-exceed="handleExceed"
            :before-upload="(file) => beforeUpload(file, fileVideoType, fileVideoSize)"
            :show-file-list="true"
            :headers="headers"
          >
            <!-- action="/api/file/fileUpload" -->
            <el-button
              class="btn"
              type="primary"
            ><i class="el-icon-paperclip"></i>上传视频</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传mp4 / mov / wmv / flv / avi / avchd / webm / mkv文件，且不超过200MB，只可传1份
              </div>
            </template>
          </el-upload>

        </el-form-item>

        <el-form-item label="操作手册">
          <el-upload
            :on-preview="handlePreview"
            class="upload-demo"
            action
            :http-request="(file) => uploadFile(file, 'doc')"
            ref="upload"
            :limit="fileLimit"
            :on-remove="handleRemoveDoc"
            :file-list="fileDocList"
            :on-exceed="handleExceed"
            :before-upload="(file) => beforeUpload(file, fileDocType, fileDocSize)"
            :show-file-list="true"
            :headers="headers"
          >
            <!-- action="/api/file/fileUpload" -->
            <el-button
              class="btn"
              type="primary"
            ><i class="el-icon-paperclip"></i>上传文档</el-button>
            <template #tip>
              <div class="el-upload__tip">
                只能上传txt / doc / wps / docx / xls / xlsx / pdf / pptx文件，且不超过50MB
              </div>
            </template>
          </el-upload>

        </el-form-item>


        <el-form-item>
          <el-button
            @click="resetForm(ruleFormRef)"
            v-if="false"
          >重置</el-button>
          <el-button
            type="primary"
            @click="OnSubmit"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </DefaultLayout>
</template>

<script>
export default {
  name: 'EditQRPage'
}
</script>

<script setup>
import DefaultLayout from '../../components/layout/DefaultLayout.vue'
import router from '../../router'
import { reactive, ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { QrCode } from '../../api/request'
import { useRoute } from 'vue-router'

//上传文件
//上传后的文件列表
const fileVideoList = ref([])
const fileDocList = ref([])
// 允许的文件类型
const fileVideoType = ["mp4", "mov", "wmv", "flv", "avi", "avchd", "webm", "mkv"]
const fileDocType = ["txt", "doc", "wps", "docx", "xls", "xlsx", "pdf", "pptx"]
// 运行上传文件大小，单位 M
const fileVideoSize = 50
const fileDocSize = 200
// 附件数量限制
const fileLimit = 99
//请求头
const headers = { "Content-Type": "multipart/form-data" }

const beforeUpload = (file, verify, fileSize) => {
  if (file.type != "" || file.type != null || file.type != undefined) {
    //截取文件的后缀，判断文件类型
    const FileExt = file.name.replace(/.+\./, "").toLowerCase();
    //计算文件的大小
    const isLt5M = file.size / 1024 / 1024 < fileSize; //这里做文件大小限制
    //如果大于50M
    if (!isLt5M) {
      ElMessage({
        message: `上传文件大小不能超过 ${fileSize}MB！`,
        type: 'warning',
      })
      return false;
    }
    //如果文件类型不在允许上传的范围内
    if (verify.includes(FileExt)) {
      return true;
    }
    else {
      ElMessage({
        message: '上传文件格式不正确！',
        type: 'warning',
      })
      return false;
    }
  }
}
//上传了的文件给移除的事件，由于我没有用到默认的展示，所以没有用到e
const handleRemoveVideo = (i, arr) => {
  fileVideoList.value = arr
}
const handleRemoveDoc = (i, arr) => {
  fileDocList.value = arr
}
//这是我自定义的移除事件
// const handleClose = (i) => {
//   this.fileList.splice(i, 1);//删除上传的文件
//   if (this.fileList.length == 0) {//如果删完了
//     this.fileflag = true;//显示url必填的标识
//     this.$set(this.rules.url, 0, { required: true, validator: this.validatorUrl, trigger: 'blur' })//然后动态的添加本地方法的校验规则
//   }
// }
//超出文件个数的回调
const handleExceed = () => {
  ElMessage({
    message: '超出最大上传文件数量的限制！',
    type: 'warning',
  })
  return
}
//上传文件的事件
const uploadFile = (item, type) => {
  ElMessage('文件上传中........')
  //上传文件的需要formdata类型;所以要转
  let FormDatas = new FormData()
  FormDatas.append('files', item.file);
  // console.log(item.file, FormDatas.get('files'))
  axios({
    method: "post",
    url: `https://api.iot.zs-tek.com/File/Upload`,
    data: FormDatas,
    headers: { "Content-Type": "multipart/form-data" }
  }).then((res) => {
    // console.log(res.data)
    if (type === 'video') {
      fileVideoList.value.push(item.file)
      console.log(item.file)
      let i = fileVideoList.value.indexOf(item.file)
      fileVideoList.value[i].url = 'https://api.iot.zs-tek.com' + res.data.content;
    } else if (type === 'doc') {
      fileDocList.value.push(item.file)
      let i = fileDocList.value.indexOf(item.file)
      fileDocList.value[i].url = 'https://api.iot.zs-tek.com' + res.data.content;
    }
    handleSuccess()
  })

  // this.$axios({
  //   method: 'post',
  //   url: '/file/fileUpload',
  //   headers: this.headers,
  //   timeout: 30000,
  //   data: FormDatas
  // }).then(res => {
  //   if (res.data.id != '' || res.data.id != null) {
  //     this.fileList.push(item.file);//成功过后手动将文件添加到展示列表里
  //     let i = this.fileList.indexOf(item.file)
  //     this.fileList[i].id = res.data.id;//id也添加进去，最后整个大表单提交的时候需要的
  //     if (this.fileList.length > 0) {//如果上传了附件就把校验规则给干掉
  //       this.fileflag = false;
  //       this.$set(this.rules.url, 0, '')
  //     }
  //     //this.handleSuccess();
  //   }
  // })
}
//上传成功后的回调
const handleSuccess = () => {
  ElMessage({
    message: '上传成功！',
    type: 'success',
  })
}
//上传文件

const ruleFormRef = ref()

const form = reactive({
  id: '',
  name: '',
  desc: ''
})

const OnSubmit = () => {
  // console.log(fileVideoList.value, fileDocList.value, '发送')
  const spTem = []
  fileDocList.value.forEach(element => {
    spTem.push(element.url)
  })
  QrCode.Save({
    id: form.id,
    title: form.name,
    intro: form.desc,
    video: fileVideoList.value[0]?.url,
    specifications: spTem,
    state: 1,
  }).then((res) => {
    ElMessage({
      message: '更改成功！',
      type: 'success',
    })
    router.push('/instructions/instructionsList');
    resetForm(ruleFormRef.value)
    fileVideoList.value = []
    fileDocList.value = []
  })
}

const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

onMounted(() => {
  // console.log(useRoute().query)
  QrCode.Get(useRoute().query.id).then((res) => {
    // console.log(res.content, '请求')
    form.id = res.content.id
    form.name = res.content.title
    form.desc = res.content.intro
    if (res.content.video !== null && res.content.video.url !== null) {
      fileVideoList.value.push({
        url: res.content.video.url,
        name: res.content.video.name,
        file: new File([], res.content.video.name, {})
      })
    }
    if (res.content.specifications.length > 0) {
      for (const ele of res.content.specifications) {
        fileDocList.value.push({
          url: ele.url,
          name: ele.name,
          file: new File([], ele.name, {})
        })
      }
    }
  })
})

const goPath = (path) => {
  router.push(path);
}

const handlePreview = (data) => {
  window.open(data.url, '_blank');
}
</script>

<style scoped>
.page-header {
  background-color: #F9F9F9;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
</style>
